import { useEffect } from 'react';
export var useDisableBodyScroll = function (bool) {
    if (bool === void 0) { bool = false; }
    useEffect(function () {
        document.body.style.overflow = bool ? 'hidden' : 'unset';
    }, [bool]);
};
